import Model from './Model';

export default class Counselor extends Model {
    first_name;
    last_name;
    name;

    static apiPath() {
        return 'counselors';
    }
}



// WEBPACK FOOTER //
// ./src/models/Counselor.js